// @ts-strict-ignore
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-lazy-loaded-image',
    templateUrl: './lazy-loaded-image.component.html',
    styleUrls: ['./lazy-loaded-image.component.scss'],
    standalone: false
})
export class LazyLoadedImageComponent implements OnChanges {
  @Input() alt: string = '';
  @Input() class: string;
  @Input() src: string;

  hasError = false;
  isLoading = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.src) {
      this.hasError = false;
      this.isLoading = true;
    }
  }

  onLoad() {
    this.isLoading = false;
  }

  onError() {
    this.hasError = true;
    this.isLoading = false;
    if (this.src.endsWith('?width=360')) {
      this.src = this.src.replace('?width=360', '');
    }
  }
}
